// @flow
/* eslint-disable arrow-body-style */ import React, {
  useState,
  useRef,
  useEffect,
} from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock-upgrade';
import ReactModal from 'react-modal';
import { t } from 'javascripts/utils/withTranslation';
import ErrorBoundary from 'javascripts/utils/ErrorBoundary';
import randomString from 'javascripts/utils/random-id';
import Button from 'components/atoms/button/Button';
import Icon from '../../../_particles/icon/react/Icon';
import BurgerFallBack from './BurgerFallback';
import BurgerContent from './BurgerContent';
import type { BurgerProps, ModalProps } from '../types';
import useMediaquery from '../../../../javascripts/hooks/useMediaquery';
import { MEDIA_QUERIES } from '../../../../javascripts/constants';
import BurgerContentDesktop from './BurgerContentDesktop';
import BurgerContentTablet from './BurgerContentTablet';

const Burger = ({
  isOpen,
  setIsOpen,
  ...props
}: ModalProps): React$MixedElement => {
  const isDesktop = useMediaquery(MEDIA_QUERIES.xxl);
  const isTablet = useMediaquery(MEDIA_QUERIES.l);
  const modifier = randomString();

  return (
    <>
      <button
        type="button"
        className="header__icon"
        aria-expanded={isOpen}
        aria-labelledby={`header-icon-label--burger-${modifier}`}
        onClick={() => setIsOpen(true)}
      >
        <Icon icon="burger-menu" ariaHidden={true} focusable={false} />

        <span
          id={`header-icon-label--burger-${modifier}`}
          className="header__icon-text"
          hidden
        >
          {t('Inhaltsübersicht')}
        </span>
      </button>

      <ReactModal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel={t('Menü aufgeklappt')}
        overlayClassName="modal__overlay"
        className="modal"
        aria={{
          labelledby: `header-icon-label--burger-${modifier}`,
        }}
      >
        <section className="modal__section">
          <ErrorBoundary>
            <div className="modal__header">
              <div className="header__container">
                <h2 className="u-hidden-visually" id="burger-headline">
                  {t('Detailliertes Menü')}
                </h2>
                <Button
                  icon="close"
                  iconTitle={t('Schließen')}
                  className="modal__close"
                  style="chromeless"
                  onClick={() => setIsOpen(false)}
                />
              </div>
            </div>
            <div
              className="modal__content"
              ref={(node) => {
                if (isOpen && node) {
                  disableBodyScroll(node);
                } else if (node) {
                  enableBodyScroll(node);
                }
              }}
            >
              {!isDesktop && !isTablet && <BurgerContent {...props} />}
              {!isDesktop && isTablet && <BurgerContentTablet {...props} />}
              {isDesktop && <BurgerContentDesktop {...props} />}
            </div>
          </ErrorBoundary>
        </section>
      </ReactModal>
    </>
  );
};

export default Burger;
